// extracted by mini-css-extract-plugin
export default {"current-bill-date-container":"styles_current-bill-date-container__LaNIC","current-bill-date":"styles_current-bill-date__Pgp-M"};